import * as React from "react";
import styled from "styled-components";
import { HeadingLink } from "../../Text";
import { COLOURS } from "../../../consts/style";
import { ProspectSvg } from "../../Svg/ProspectSvg";
import { MovingSvg } from "../../Svg/MovingSvg";
import safeGet from "lodash/get";

const InnerContainer = styled.a`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  max-width: 375px;
  text-decoration: none;
`;

const StyledText = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: ${COLOURS.GREY.GREY_80};
`;

const ImageContainer = styled.div`
  width: 104px;
`;

const HeadingContainer = styled.div`
  width: 70%;
  margin-right: 16px;
`;

const Container = styled.div`
  padding: 24px 32px;
`;

interface ContentProps {
  href: string;
  heading: string;
  text: string;
  Image: () => JSX.Element;
}

export const Content: React.SFC<ContentProps> = ({
  href,
  heading,
  text,
  Image
}) => (
  <InnerContainer href={href}>
    <HeadingContainer>
      <HeadingLink inline>{heading}</HeadingLink>
      <StyledText>{text}</StyledText>
    </HeadingContainer>
    <ImageContainer>
      <Image />
    </ImageContainer>
  </InnerContainer>
);

const prospectContent = {
  href: "/for-home/electricity-and-gas/plans/energy-plans.html",
  heading: "Electricity and gas",
  text: "Compare our energy plans side by side.",
  Image: ProspectSvg
};

const movingContent = {
  href: "/for-home/moving.html",
  heading: "Moving house?",
  text: "We'll connect you.",
  Image: MovingSvg
};

interface PersonalisedContentState {
  show: boolean;
  prospect: boolean;
  moving: boolean;
}

interface Audience {
  prospect?: boolean;
  moving?: boolean;
}

interface OfferContent {
  content: Audience[];
}

export class PersonalisedContent extends React.Component<
  {},
  PersonalisedContentState
> {
  state = { show: false, prospect: false, moving: false };

  componentDidMount() {
    if (safeGet(window, "adobe.target.getOffer")) {
      window.adobe.target.getOffer({
        mbox: "OE-234-mbox",
        success: (offer: OfferContent[]) => {
          const prospect = safeGet(offer, "[0].content[0].prospect");
          const moving = safeGet(offer, "[0].content[0].moving");
          if (prospect) {
            this.setState({ show: true, prospect: true });
          } else if (moving) {
            this.setState({ show: true, moving: true });
          }
        },
        error: () => {}
      });
    }
  }

  render() {
    if (!this.state.show) {
      return null;
    }

    return (
      <Container>
        {this.state.prospect && <Content {...prospectContent} />}
        {this.state.moving && <Content {...movingContent} />}
      </Container>
    );
  }
}
